module.exports = __webpack_public_path__ + "img/40_69_012_190.676855b0.jpg";